import React, { FC } from 'react';
import { Image as NativeImage } from '@tarojs/components';
import classNames from 'classnames';
import { ImageProps } from '@tarojs/components/types/Image';

const Image: FC<ImageProps> = ({ className, ...restProps }) => <NativeImage className={classNames('ink-image', className)} {...restProps} />;

export default Image;
